module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pull-reload",
    style: ({
      minHeight: _vm.minHeight + 'px'
    })
  }, [_c('div', {
    staticClass: "hidden",
    class: {
      transition: !_vm.noAnimation
    },
    style: ({
      transform: 'translateY(' + (_vm.loading ? 50 : _vm.pullY) / 2 + 'px)'
    })
  }, [(!_vm.loading) ? _c('span', [_vm._v(_vm._s(_vm.pullY > _vm.threshold ? "松开" : "下拉") + "刷新")]) : _c('span', [_vm._v("载入中...")])]), _vm._v(" "), _c('div', {
    staticClass: "inner",
    class: {
      transition: !_vm.noAnimation
    },
    style: ({
      transform: 'translateY(' + (_vm.loading ? 50 : _vm.pullY) + 'px)'
    })
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3caa8f6f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PullReload.vue
// module id = 82
// module chunks = 1